import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import "./Entreprise.css";
import Breadcrumb from './Breadcrumb';
import WhatYouLearn from './WhatYouLearn';
import CallToAction from './CallToAction';
import DiagnosticProjets from './Diagnosticprojets'
import ConduiteProjet from './Conduiteprojet';
import ControleProjet from './Controleprojet';
import ConduiteBlock from './ConduiteBlock';
import ControleBlock from './ControleBlock';
import entrepriseImage from '../assets/entreprise.png';

const Entreprise = () => {
  const navigate = useNavigate();

  // État pour les données du hero (titre et description de la rubrique)
  const [heroData, setHeroData] = useState({
    title: "Entreprise",
    subtitle: "Des solutions sur mesure pour optimiser la performance de vos projets",
    text: "Découvrez nos trois offres complémentaires conçues pour répondre aux défis spécifiques de votre organisation en matière de gestion de projet.",
    backgroundImage: entrepriseImage
  });

  // État pour les services (les articles de la rubrique)
  const [services, setServices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Récupérer les données depuis l'API
  useEffect(() => {
    fetchEntrepriseData();
  }, []);

  const fetchEntrepriseData = async () => {
    try {
      setIsLoading(true);

      const response = await fetch(`${process.env.REACT_APP_HOTE}api/rubriques/by-url/Entreprises`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.success && data.data) {
        const rubriqueData = data.data;

        // Fonction pour nettoyer le HTML
        const cleanText = (html) => {
          if (!html) return '';
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          return tempDiv.textContent || tempDiv.innerText || '';
        };

        // 1. Mettre à jour les données du hero (titre, sous-titre, description de la rubrique)
        // setHeroData({
        //   title: cleanText(rubriqueData.titre) || "Entreprises",
        //   subtitle: cleanText(rubriqueData.soustitre) || "Des solutions sur mesure pour optimiser la performance de vos projets.",
        //   text: cleanText(rubriqueData.descriptif) || "Découvrez nos trois offres complémentaires conçues pour répondre aux défis spécifiques de votre organisation en matière de gestion de projet."
        // });

        // 2. Récupérer les articles (services) depuis l'API
        if (rubriqueData.articles && rubriqueData.articles.length > 0) {
          const formattedServices = rubriqueData.articles.map((article, index) => {
            // Déterminer le chemin et la couleur en fonction du titre
            let path = "#";
            let color = "";

            if (article.titre === "Diagnostic de projets") {
              path = "/entreprises/diagnostic-projets";
              color = "#0a3764";
            } else if (article.titre === "Conduite de projets") {
              path = "/entreprises/conduite-projet";
              color = "#1a538a";
            } else if (article.titre === "Contrôle de projet") {
              path = "/entreprises/controle-projet";
              color = "#2c5a8c";
            }

            return {
              id: article.id_article,
              title: cleanText(article.titre),
              description: cleanText(article.soustitre) || cleanText(article.descriptif),
              path: path,
              color: color
            };
          });
          setServices(formattedServices);
        }
        else {
          // Services par défaut si pas d'articles
          setServices([
            {
              id: 1,
              title: "Diagnostic de projets",
              description: "Identifiez rapidement les causes des dysfonctionnements de vos projets et mettez en place des solutions concrètes.",
              path: "/entreprises/diagnostic-projets",
              color: "#0a3764"
            },
            {
              id: 2,
              title: "Conduite de projets",
              description: "Accompagnement dans la conduite de projets orientée valeur, du cadrage à la mise en production.",
              path: "/entreprises/conduite-projet",
              color: "#1a538a"
            },
            {
              id: 3,
              title: "Contrôle de projet",
              description: "Maîtrise rigoureuse des délais, des coûts et des performances globales de vos projets.",
              path: "/entreprises/controle-projet",
              color: "#2c5a8c"
            }
          ]);
        }
      } else {
        throw new Error('Données de rubrique non disponibles');
      }

    } catch (err) {
      console.error('Erreur lors de la récupération des données:', err);
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Fonction pour gérer la redirection vers la page contact
  const handleContactClick = () => {
    navigate("/contactez-nous#form"); // Redirige vers la page /contact
  };

  if (isLoading) {
    return (
      <>
        <Breadcrumb />
        <section className="section what-you-learn" id="programme" >
          <div className="contenir">
            <h2 className="section-title">Entreprise</h2>
            <p className="section-subtitle">
              chargement....
            </p>
          </div>
        </section>
      </>
    );
  }

  if (error) {
    return (
      <section className="section what-you-learn" id="programme" >
        <div className="contenir">
          <h2 className="section-title">Entreprise</h2>
          <p className="section-subtitle" style={{ color: '#ff6b6b' }}>
            Erreur de chargement : {error}
          </p>
        </div>
      </section>
    );
  }

  return (
    <>
      <Breadcrumb />
      <div className="entreprise-page">
        {/* Hero Section */}
        <div className="entreprise-page-hero">
          <img
            src={heroData.backgroundImage}
            alt="Background"
            className="entreprise-page-hero-bg"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
          <div className="entreprise-page-hero-overlay"></div>
          <div className="entreprise-page-hero-content">
            <h1 className="entreprise-page-hero-title">{heroData.title}</h1>
            <p className="entreprise-page-hero-subtitle">
              {heroData.subtitle}
            </p>
            <p className="entreprise-page-hero-text">
              {heroData.text}
            </p>
          </div>
        </div>

        {/* Services Grid - Dynamique depuis l'API */}
        {/* <div className="entreprise-page-services">
          <div className="entreprise-page-services-grid">
            {services.map((service) => (
              <div
                key={service.id}
                className="entreprise-page-service-card"
                style={{ '--card-color': service.color }}
              >
                <h2 className="entreprise-page-service-card-title">{service.title}</h2>
                <p className="entreprise-page-service-card-description">{service.description}</p>

                <button
                  className="entreprise-page-service-card-button"
                  onClick={() => navigate(service.path)}
                >
                  Découvrir
                  <span className="entreprise-page-arrow">→</span>
                </button>
              </div>
            ))}
          </div>
        </div> */}

        <DiagnosticProjets />

        {/* SECTION DEUX BLOCS CÔTE À CÔTE - Conduite et Contrôle */}
        {/* SECTION CONDUITE ET CONTROLE - Version côte à côte */}
        {/* SECTION CONDUITE ET CONTROLE - Background divisé en deux */}
        <div className="split-background-container">
          <div className="split-background-left"></div>
          <div className="split-background-right"></div>

          <div className="two-blocks-wrapper">
            <div className="block-item">
              <ConduiteBlock />
            </div>
            <div className="block-item">
              <ControleBlock />
            </div>
          </div>
        </div>

        <WhatYouLearn />

        {/* Call to Action */}
        {/* <div className="conduite-page-cta">
          <div className="conduite-page-cta-content">
            <button className="conduite-page-cta-button">
              Demander un RDV
            </button>
          </div>
        </div> */}

        <CallToAction
          title="Prêt à collaborer avec nous ?"
          // button1Text="Ecrire WhatsApp"
          button2Text="Demander RDV"
          // onButton1Click={() => window.open('https://wa.me/2290158585050', '_blank')}
          onButton2Click={handleContactClick}
          // button1Icon={<FaWhatsapp />}
          showButton1={false}
        />
      </div>
    </>
  );
};

export default Entreprise;